import { paths } from '@/app/routes';
import { DealMenu } from '@/components/DealMenu';
import { FolioDrawerHeader } from '@/components/Drawers/FolioDrawer/FolioDrawerHeader';
import { useObjectContext } from '@/hooks/useObjectContext';
import { usePreviewMode } from '@/hooks/usePreviewMode';
import { getUrlFromPipeline } from '@/utils/constants';
import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const PreviewDrawerHeader = () => {
	const { closePreview } = usePreviewMode();

	const { clientRow, dealRow, isClientView, clientId, dealId } = useObjectContext();
	const navigate = useNavigate();

	const isProspect = clientRow?.isProspect;

	const isClaim = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_CLAIMS;
	const isDebtor = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_DEBTORS;

	const headerPrefix = isProspect ? 'prospect' : 'client';

	const objectLink = isClientView
		? `${isProspect ? paths.prospects : paths.clients}/${clientId}`
		: `${getUrlFromPipeline(dealRow?.pipeline)}/${dealId}`;

	const getViewButtonText = () => {
		if (isClientView) return `View ${headerPrefix}`;
		if (isClaim) return 'View claim';
		if (isDebtor) return 'View debtor';
		return 'View deal';
	};

	return (
		<FolioDrawerHeader
			headerActions={
				<>
					{!isClientView && <DealMenu minimal />}
					<Button
						variant='text'
						color='primary'
						onClick={(event) => {
							event.stopPropagation();
							closePreview(event);
							navigate(objectLink);
						}}
					>
						{getViewButtonText()}
					</Button>
				</>
			}
		/>
	);
};

PreviewDrawerHeader.displayName = 'PreviewDrawerHeader';
export default PreviewDrawerHeader;
